import { withStyles } from '@glu/theming';
import classNames from 'classnames';
import { HtmlHTMLAttributes } from 'react';

import styles from './Layout.styles';

export interface ILayoutProps extends HtmlHTMLAttributes<HTMLOrSVGElement> {
  classes: Record<keyof ReturnType<typeof styles>, string>;
  /** The tag to render. By default renders a div */
  tag?: keyof JSX.IntrinsicElements;
  /**
   * Whether or not this is a container or not. A container is meant to contain other Layout elements.
   */
  container?: boolean;
  theme?: Record<string, unknown>;
  /** The number of columns the specific container takes up. Defaults to 12 */
  col?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
}

export const Layout = ({
  children,
  className,
  classes,
  col = 12,
  container,
  tag: Tag = 'div',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  theme: _theme,
  ...rest
}: ILayoutProps) => (
  <Tag
    className={classNames(
      className,
      container ? classes.container : [classes.col, classes[`col${col}`]]
    )}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...rest}
  >
    {children}
  </Tag>
);

export const BareLayout = Layout;
export default withStyles(styles)(Layout);
